import { supabase } from '../lib/supabase';

export const stripePaymentService = {
  // Create payment intent for escrow transaction
  async createEscrowPayment(offerData, buyerInfo) {
    try {
      const { data, error } = await supabase?.functions?.invoke('create-escrow-payment', {
        body: {
          offerData,
          buyerInfo
        }
      });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error creating escrow payment:', error);
      return { data: null, error: error?.message || 'Failed to create escrow payment' };
    }
  },

  // Confirm payment and update escrow status
  async confirmEscrowPayment(paymentIntentId) {
    try {
      const { data, error } = await supabase?.functions?.invoke('confirm-escrow-payment', {
        body: { paymentIntentId }
      });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error confirming escrow payment:', error);
      return { data: null, error: error?.message || 'Failed to confirm escrow payment' };
    }
  },

  // Release escrow funds to seller
  async releaseEscrowFunds(transactionId) {
    try {
      const { data, error } = await supabase?.functions?.invoke('release-escrow-funds', {
        body: { transactionId }
      });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error releasing escrow funds:', error);
      return { data: null, error: error?.message || 'Failed to release escrow funds' };
    }
  },

  // Refund escrow payment
  async refundEscrowPayment(transactionId, reason) {
    try {
      const { data, error } = await supabase?.functions?.invoke('refund-escrow-payment', {
        body: { transactionId, reason }
      });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error refunding escrow payment:', error);
      return { data: null, error: error?.message || 'Failed to refund escrow payment' };
    }
  },

  // Format currency amount
  formatAmount(amount, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    })?.format(amount);
  },

  // Calculate platform fee (e.g., 5% of transaction)
  calculatePlatformFee(amount, feePercentage = 5) {
    return (amount * feePercentage) / 100;
  },

  // Calculate seller payout after fees
  calculateSellerPayout(amount, feePercentage = 5) {
    const fee = this.calculatePlatformFee(amount, feePercentage);
    return amount - fee;
  }
};

export default stripePaymentService;
